export default __webpack_public_path__ + "static/media/cssda-special-kudos.685a26fe.webp";